<template>
  <div class="owner-box">
    <div class="main-container">
      <h2 class="">パスワード変更</h2>

      <div class="popup-contents-box">

        <div class="sub-contents-box">
          <div class="customer-info">
            <div class="flex">
              <p class="info-title">現在のパスワード</p>
              <p class="info-item"><input type="password" v-model="old_pass" /></p>
            </div>

            <div class="flex">
              <p class="info-title">新しいパスワード</p>
              <p class="info-item"><input type="password" v-model="new_pass"></p>
            </div>

            <div class="flex">
              <p class="info-title">パスワード(確認用)</p>
              <p class="info-item"><input type="password" v-model="new_pass2"></p>
            </div>

          </div>
          <p><span class="red">※</span>全て入力してください。</p>
        </div>

      </div>
      <div class="flex2">
        <input type="button" class="new-add" @click="edit" value="決定" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Owner',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      old_pass: null,
      new_pass: null,
      new_pass2: null,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    edit () {
      if (this.$lib._emptyChk(this.old_pass) === false) {
        this.$alert('alert', '現在のパスワードを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.new_pass) === false) {
        this.$alert('alert', '新しいパスワードを入力してください。');
        return;
      }
      if (this.$lib._emptyChk(this.new_pass2) === false) {
        this.$alert('alert', 'パスワード(確認用)を入力してください。');
        return;
      }
      if (this.new_pass !== this.new_pass2) {
        this.$alert('alert', '新しいパスワードとパスワード(確認用)が一致しません。');
        return;
      }

      let ld = new this.$loader(this);
      ld._data_set({old_user_pass: this.old_pass, user_pass: this.new_pass, user_pass2: this.new_pass2});
      ld._post_cb_f = this.edit_cb;
      ld._load_start('admin_password_edit.php');
    },
    edit_cb () {
      this.$alert('info', 'パスワードを変更しました。');
      this.$router.push({name: 'unregistered', params: {}});
    }

  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.owner-box {
  text-align: left;

  .main-container {

    .popup-contents-box {
      margin: 20px 0;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      height: calc(100% - 120px);
      .guide-p {
        height: 40px;
        overflow: auto;
      }
    }
    .sub-contents-box {
      margin-bottom: 0px;
      margin-right: 0px;
    }
    .new-add {
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }

    .customer-info {
      border-bottom: 1px solid #d3d4d8;
    }

    .info-title {
      min-width: 180px;
      padding: 3px 13px 3px 3px;
      background: #fbfbfb;
      text-align: right;
      line-height: 1.8;
      border-top: 1px solid #d3d4d8;
      border-left: 1px solid #d3d4d8;
      color: #24273b;
    }

    .info-item {
      padding: 5px;
      flex: 1;
      border-top: 1px solid #d3d4d8;
      border-left: 1px solid #d3d4d8;
      border-right: 1px solid #d3d4d8;
      background: #fbfbfb;
    }
    .flex2 {
      display: flex;
      justify-content:space-between;
    }
    .flex3 {
      display: flex;
      select {
        margin-right: 10px;
      }
    }
    .red {
      color: #ff6e5a;
    }

  }
  @media (max-width: 767px) {
    .main-container {
    }
  }
}
</style>
